import React from 'react';
import '../styles/NewsPage.css'
import NewsImage from '../assets/news_image.jpeg'

const NewsPage = () => {
    return (
        <>
            <div className="row">
                <div className="news_wrapper">
                    <h1 className="news_title">Demo News Title</h1>
                    <div className="news_image-content-wrapper">
                        <img src={NewsImage} alt="" className="news_image" />
                        <p className="news_content">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                            Minima unde doloremque eaque odit, sit aliquam eius modi assumenda illo alias placeat
                            iste mollitia accusamus aperiam fugit consectetur, amet sunt. Laudantium voluptas ipsum
                            exercitationem laborum illum deserunt blanditiis nobis harum! Quas ut accusantium,
                            nostrum, dolorem fugit tempora aspernatur dolorum assumenda totam et omnis. Cupiditate
                            dolorem corrupti minima recusandae. Assumenda eligendi, quisquam dolorem necessitatibus
                            dicta consectetur iste, quaerat porro dignissimos adipisci atque aperiam blanditiis in. Totam
                            quaerat labore ipsum? Excepturi sunt accusantium amet maiores tempore neque officia molestiae
                            repudiandae sapiente, voluptate cum, accusamus ratione reiciendis. Et, natus. Iusto nulla
                            et libero iste.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewsPage;
